import { css } from 'styled-components';
import { colorCSS } from './colors';
import { radius } from './radius';
export const formCSS = css `
  input,
  select,
  textarea,
  button[type='submit'] {
    background: ${colorCSS('N20')};
    border: 1px solid ${colorCSS('N40')};
    border-radius: ${radius.small};
    margin-bottom: 0.75rem;
    padding: 0.4rem 0.8rem;
    width: 100%;
    transition: 250ms ease-out;
    &:focus {
      border-color: ${colorCSS('B300', 0.5)};
      box-shadow: 0 0 0 3px ${colorCSS('B300', 0.15)};
      outline: none;
    }
  }

  select {
    appearance: none;
  }

  textarea {
    min-height: 8rem;
  }

  button[type='submit'] {
    background-color: ${colorCSS('B300')};
    border: 1px solid ${colorCSS('B300')};
    color: ${colorCSS('N0')};
    margin-top: 1rem;
    width: auto;
    &:hover {
      background-color: ${colorCSS('B400')};
      border-color: ${colorCSS('B400')};
    }
    &:active {
      background-color: ${colorCSS('B500')};
      border-color: ${colorCSS('B500')};
    }
    &:focus {
      box-shadow: 0 0 0 0.2rem ${colorCSS('B400', 0.5)};
    }
  }
`;
//# sourceMappingURL=form.js.map